const SAFE_LOCAL_NAME = /^[A-Za-z_$][\w$]*$/;

/**
 * Evaluate a template that references a local by name (e.g. `request`, `item`).
 * Binds that name via Function's formal parameter so production minify cannot
 * rename it and break eval strings. Uses eval so expression and if/else
 * statement templates keep the same completion-value behavior as direct eval.
 */
export function evalWithNamedLocal(
  localName: string,
  code: string,
  localValue: unknown
): unknown {
  if (!SAFE_LOCAL_NAME.test(localName)) {
    throw new Error(`Invalid local name for eval: ${localName}`);
  }
  // eslint-disable-next-line no-new-func, no-eval
  return new Function(
    localName,
    `return eval(${JSON.stringify(code)});`
  )(localValue);
}
